import {
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  SimpleGrid,
} from "@chakra-ui/react";//HStack,
import { Card, Search } from "@/components/index";//, Filter, Sort

export function MainContent({ query, link, search }) {
  return (
    <>
      <Tabs variant="enclosed" size="md" mt={[2,4]}> 
        <TabList>
          <Tab>Resources</Tab>
          {/* {auth.user ? (
            <>
            <Tab>Favorites</Tab>
            <Tab>My Courese</Tab>
            </>
            ) : (
              <>
              <Tab isDisabled>Favorites</Tab>
              <Tab isDisabled>My Courese</Tab>
              </>
            )} */}
        </TabList>
        <Search ph={search} />
        {/* <HStack justify="space-between" mx={[6]}>
          <Filter>Age</Filter>
          <Sort />
        </HStack> */}
        <TabPanels>
          <TabPanel>
            <SimpleGrid
              minChildWidth={["14rem", "16rem", "18rem"]}
              columns={[1, 2, 3, 4]}
              gap={["4", "12", "28"]}
              justifyItems="center"
              justifyContent="space-evenly"
              alignContent="space-evenly"
              alignItems="center"
              m={[2, 6, 10]}
            >
              <Card link={link} query={query} />
              <Card />
              <Card />
              <Card />
              <Card />
              <Card />
            </SimpleGrid>
          </TabPanel>
          {/* <TabPanel>
          <SimpleGrid
            columns={[1, null, 3]}
            spacingX={[0, 3]}
            spacingY={4}
            minChildWidth="300px"
            w="95%"
            m="0 auto"
          >
            <Card />
            <Card link={link} query={query} />
            <Card />
            <Card />
          </SimpleGrid>
        </TabPanel> */}
          {/* <TabPanel>
          {" "}
          <SimpleGrid
            columns={[1, null, 3]}
            spacingX={[0, 3]}
            spacingY={4}
            minChildWidth="300px"
            w="95%"
            m="0 auto"
          >
            <Card />
            <Card link={link} query={query} />
          </SimpleGrid>
        </TabPanel> */}
        </TabPanels>
      </Tabs>
    </>
  );
}
